import { render, staticRenderFns } from "./Internship.vue?vue&type=template&id=f48a7cd8&scoped=true&"
import script from "./Internship.vue?vue&type=script&lang=js&"
export * from "./Internship.vue?vue&type=script&lang=js&"
import style0 from "./Internship.vue?vue&type=style&index=0&id=f48a7cd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48a7cd8",
  null
  
)

export default component.exports